"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerLogout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const material_1 = require("@mui/material");
const hooks_1 = require("../../../hooks");
const CustomerLogout = () => {
    const { isLogged, handleLogout } = (0, hooks_1.useCustomer)();
    if (!isLogged) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.ListItem, Object.assign({ disablePadding: true }, { children: (0, jsx_runtime_1.jsxs)(flora_react_1.Button, Object.assign({ variant: "unstyled", css: { height: 'inherit' }, "autotagging-flora": "on", "data-flora-text": "sair da conta", as: material_1.ListItemButton, onClick: handleLogout }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, Object.assign({ sx: { minWidth: 0, marginRight: '10px' } }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.RectangleArrowRightIcon, { color: "$nonInteractivePredominant" }) })), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyLargeShortRegular" }, { children: "Sair da conta" })) })] })) })));
};
exports.CustomerLogout = CustomerLogout;
